import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireReactResponsive } from '../node_modules/react-responsive/dist/react-responsive.js';

var reactResponsiveExports = requireReactResponsive();
var MediaQuery = /*@__PURE__*/getDefaultExportFromCjs(reactResponsiveExports);

export { MediaQuery as default };
